import { render, staticRenderFns } from "./EnrollmentOrderListItem.vue?vue&type=template&id=04d523f1&scoped=true&"
import script from "./EnrollmentOrderListItem.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentOrderListItem.vue?vue&type=script&lang=ts&"
import style0 from "./EnrollmentOrderListItem.vue?vue&type=style&index=0&id=04d523f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d523f1",
  null
  
)

export default component.exports